import React from 'react';
import {Form, Edit, Suggestions, List} from 'components';
import {useNamedSelector} from 'helpers';

export function DreamsInquiry1() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'dreams-inquiry-1' })}>
      <List tiny-gutter>
        <List.Title>What would you want to do with your life if you had no limitations?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="1" />
        <List.Title>What would you want to accomplish if you were absolutely certain of success?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="2" />
        <List.Title>What things have you always wanted to do, but were afraid to try?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="3" />
        <List.Title>What would you do if you had enough money to stop working?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="4" />
        <List.Title>What would you do if you won ten million dollars?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="5" />
        <List.Title>What were your dreams five or ten years ago?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="6" />
        <List.Title>What were your dreams when you were a child?</List.Title>
        <Edit Suggestions={Suggestions.Dreams} name="7" />
      </List>
    </Form>
  );
}
